import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { ButtonColor, ButtonVariant, Icon, IconButton, Skeleton, Typography } from '../../../../../components';
import { addHiddenContext, addObjection, addPriority, addQuestion } from '../../../../../redux/reducers';
import { ComponentSize, KnowledgeHubRecordType } from '../../../../../types';

const SKELETON_SIZE = 20;

const KNOWLEDGE_HUB_TYPE_TO_BG_CLASSNAME = {
  [KnowledgeHubRecordType.PRIORITY]: 'hover:bg-green-50/20',
  [KnowledgeHubRecordType.OBJECTION]: 'hover:bg-red-50/20',
  [KnowledgeHubRecordType.QUESTION]: 'hover:bg-blue-50/20',
  [KnowledgeHubRecordType.HIDDEN_CONTEXT]: 'hover:bg-purple-50/20',
};

type LoadingScenarioPanelItemProps = {
  content?: never;
  loading: true;
  type?: never;
};

type LoadedScenarioPanelItemProps = {
  content: string;
  loading?: false;
  type: KnowledgeHubRecordType;
};

type ScenarioPanelItemProps = LoadingScenarioPanelItemProps | LoadedScenarioPanelItemProps;

export type ScenarioPanelItemComponent = React.ReactElement<ScenarioPanelItemProps>;

const ScenarioPanelItem = ({ content, loading, type }: ScenarioPanelItemProps) => {
  const dispatch = useDispatch();

  const baseClasses = 'p-4';

  const getButtonColor = () => {
    switch (type) {
      case KnowledgeHubRecordType.PRIORITY:
        return ButtonColor.PRIMARY;
      case KnowledgeHubRecordType.OBJECTION:
        return ButtonColor.DESTRUCTIVE;
      case KnowledgeHubRecordType.QUESTION:
        return ButtonColor.SECONDARY;
      case KnowledgeHubRecordType.HIDDEN_CONTEXT:
        return ButtonColor.TERTIARY;
    }
  };

  const handleClick = () => {
    switch (type) {
      case KnowledgeHubRecordType.PRIORITY:
        dispatch(addPriority(content));
        break;
      case KnowledgeHubRecordType.OBJECTION:
        dispatch(addObjection(content));
        break;
      case KnowledgeHubRecordType.QUESTION:
        dispatch(addQuestion(content));
        break;
      case KnowledgeHubRecordType.HIDDEN_CONTEXT:
        dispatch(addHiddenContext(content));
        break;
    }
  };

  if (loading) {
    return (
      <div className={baseClasses}>
        <Skeleton size={SKELETON_SIZE} />
      </div>
    );
  }

  return (
    <div
      className={clsx(baseClasses, 'cursor-pointer rounded-[4px]', KNOWLEDGE_HUB_TYPE_TO_BG_CLASSNAME[type])}
      onClick={handleClick}
    >
      <div className="flex gap-4">
        <IconButton
          icon={Icon.PLUS}
          color={getButtonColor()}
          size={ComponentSize.X_SMALL}
          variant={ButtonVariant.SOFT}
          onClick={handleClick}
        />
        <Typography>{content}</Typography>
      </div>
    </div>
  );
};

export default ScenarioPanelItem;
